<template>
    <div class="quarter-panel">
        <div class="quarter-panel-header">
            <i class="quarter-panel-header-icon el-icon-d-arrow-left" @click="currentYear--" />
            <div class="quarter-panel-header-title">{{ currentYear }} 年</div>
            <i class="quarter-panel-header-icon el-icon-d-arrow-right" @click="currentYear++" />
        </div>
        <div class="quarter-panel-content">
            <div v-for="option in quarterOptions" class="quarter-panel-item-btn" :class="getComputedClass(option.value)"
                :key="option.value" @click="emitClick(option.value)">
                {{ option.label }}
            </div>
        </div>
    </div>
</template>

<script>
import dayjs from 'dayjs'
import customParseFormat from 'dayjs/plugin/customParseFormat'

dayjs.extend(customParseFormat)

export default {
    name: 'QuarterPanel',
    props: {
        value: {
            type: String,
            default: ''
        },
        dice: {
            type: Number,
            default: 0
        },
        min: {
            type: String,
            default: ''
        },
        max: {
            type: String,
            default: ''
        },
        todayDisabled: {
            type: Boolean,
            default: false
        },
        featureDisabled: {
            type: Boolean,
            default: false
        },
    },
    data() {
        return {
            currentYear: 2023,
        }
    },
    computed: {
        day() {
            if (this.value) {
                return dayjs(this.value, 'YYYY-MM-DD')
            }
            return dayjs()
        },
        computedDate() {
            if(!this.value) return ''
            return this.day.startOf('quarter').format('YYYY-MM-DD')
        },
        quarterOptions() {
            return [
                { label: 'Q1', value: `${this.currentYear}-01-01` },
                { label: 'Q2', value: `${this.currentYear}-04-01` },
                { label: 'Q3', value: `${this.currentYear}-07-01` },
                { label: 'Q4', value: `${this.currentYear}-10-01` },
            ]
        },
    },
    mounted() {
        this.currentYear = dayjs().year()
    },
    methods: {
        getDisabled(value) {
            let isFeature = false

            if (this.todayDisabled) {
                isFeature = dayjs()
                    .subtract(1, 'day')
                    .startOf('quarter')
                    .isBefore(dayjs(value))
            } else if (this.featureDisabled) {
                isFeature = dayjs().startOf('quarter').isBefore(dayjs(value))
            }

            const isMin = this.min
                ? dayjs(this.min, 'YYYY-MM-DD')
                    .startOf('quarter')
                    .isAfter(dayjs(value, 'YYYY-MM-DD'))
                : false

            const isMax = this.max
                ? dayjs(this.max, 'YYYY-MM-DD')
                    .startOf('quarter')
                    .isBefore(dayjs(value, 'YYYY-MM-DD'))
                : false

            return isFeature || isMin || isMax
        },
        getComputedClass(value) {
            if (this.computedDate === value) {
                return 'quarter-panel-item-btn-active'
            }
            if (this.getDisabled(value)) {
                return 'quarter-panel-item-btn-disabled'
            }
            return ''
        },
        emitClick(value) {
            if (this.getDisabled(value)) {
                return
            }
            this.$emit('input', value)
        },
        clearValue() {
            this.$emit('input', '')
        }
    },
    watch: {
        dice() {
            this.currentYear = this.day.year()
        },
    },
}
</script>

<style lang="scss" scoped>
$--gw-primary-color: #f6674f;

.quarter-panel {
    width: 200px;
    color: #303133;

    .quarter-panel-header {
        height: 30px;
        padding: 20px 0;
        display: flex;
        align-items: center;
        border-bottom: solid 1px #EBEEF5;

        .quarter-panel-header-icon {
            font-size: 12px;
            margin: 5px;
            cursor: pointer;

            // &:hover {
            //   color: $--gw-primary-color;
            // }
        }

        .quarter-panel-header-title {
            flex: 1;
            text-align: center;
            font-size: 16px;
        }
    }

    .quarter-panel-content {
        margin-top: 10px;
        display: flex;
        align-items: center;

        .quarter-panel-item-btn {
            flex: 1;
            font-size: 14px;
            height: 30px;
            line-height: 30px;
            text-align: center;
            cursor: pointer;
            border: solid 1px transparent;
            border-radius: 5px;
            margin: 0 2px;

            // &:hover {
            //   color: $--gw-primary-color;
            //   border: solid 1px $--gw-primary-color;
            // }
        }

        .quarter-panel-item-btn-active {
            font-weight: bold;
            // background: $--gw-primary-color;
            // color: #ffffff;

            // &:hover {
            //   color: #ffffff;
            // }
        }

        .quarter-panel-item-btn-disabled {
            color: #909399;
            background: #f2f6fc;
            cursor: not-allowed;

            &:hover {
                color: #909399;
                background: #f2f6fc;
            }
        }
    }
}
</style>